import { cloneDeep } from 'lodash'

import { BILLING_ROUTES } from '@/routes/billing-routes'

export const AZURE_APP_SETTINGS_ROUTES = [cloneDeep(BILLING_ROUTES)]
